import { Link } from 'react-router'; // For navigation links (optional)
import styled from 'styled-components';
import {Ts, LangSwitcher} from '../../config/switcher';
import { ScrollTo } from '../Shared/ViewControl';
import { ServiceSwitcher } from '../../apps/switcher';


const HeaderContainer = styled.header`
  display: flex;
  align-items: center;
  padding: 0;
  height: 5rem;
  visibility: visible;
  background-color: #f5f5f5; /* Light gray background */
`;


const Logo = styled.img`
  height: 5rem;
  margin: 0 1rem;
`;

const NavLinks = styled.ul`
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  height: 2rem;
  vertical-align: middle;

`;


const Header = ({lang, onLang, account, service, onAccount}) => {

  const T = (value, key='header') => Ts(lang, key, value)

  const onService = (name) => {
    onAccount({...account, app:name})
  }


  return (
    <HeaderContainer id="Header">
      <Link to="/">
        <Logo src={service.logo} alt={service.domain} />
      </Link>
      <LangSwitcher lang={lang} onLang={onLang} />
      <NavLinks>
        <ScrollTo to="about" label={T('about')} />
        <ScrollTo to="plans" label={T('plan')} />
        <ScrollTo to="articles" label={T('article')} />
        <ScrollTo to="contact" label={T('contact')} />
        <ScrollTo to="GetApp" label={T('download')} style={{width:'9rem'}} />
      </NavLinks>
      { account?.connected ?
          <ServiceSwitcher service={service.name} onService={onService} />
        : null }


    </HeaderContainer>
  );
};

export default Header;
